(function () {
  'use strict';

  function isSwatchAdd(body) {
    if (!body || !Array.isArray(body.items) || !body.items.length) return false;
    return body.items.some(function (item) {
      return !!(item && item.properties && item.properties._is_swatch === 'true');
    });
  }

  document.addEventListener('loxa:before:cartAdd', function (e) {
    if (!e.cancelable) return;
    if (isSwatchAdd(e.detail && e.detail.parsedBody)) e.preventDefault();
  });
})();
